import type { ModernRawBusinessDataRequest, VaultData } from '@onefootprint/request-types';
import { BootstrapOnlyBusinessPrimaryOwnerStake, BootstrapOnlyBusinessSecondaryOwnersKey } from '@onefootprint/types';
import type { BootstrapData } from '@/idv/types';

/** Keys that are valid for bootstrap but should NOT be sent to vault API */
const BOOTSTRAP_ONLY_KEYS = [BootstrapOnlyBusinessPrimaryOwnerStake, BootstrapOnlyBusinessSecondaryOwnersKey];

export type SplitBootstrapData = {
  kycData: VaultData;
  kybData: ModernRawBusinessDataRequest;
};

/**
 * Converts IDV1 BootstrapData format to separate KYC and KYB VaultData for IDV2.
 * - KYC data: id.* fields (for collect-data route)
 * - KYB data: business.* fields (for collect-business-data route)
 * - Filters out bootstrap-only keys that shouldn't be sent to vault API
 */
const convertBootstrapToVaultData = (bootstrapData: BootstrapData): SplitBootstrapData => {
  const entries = Object.entries(bootstrapData).filter(
    ([k, v]) => v?.value !== undefined && !BOOTSTRAP_ONLY_KEYS.includes(k),
  );

  const kycData = Object.fromEntries(
    entries.filter(([k]) => k.startsWith('id.')).map(([k, v]) => [k, v.value]),
  ) as VaultData;

  const kybData = Object.fromEntries(
    entries.filter(([k]) => k.startsWith('business.')).map(([k, v]) => [k, v.value]),
  ) as ModernRawBusinessDataRequest;

  return { kycData, kybData };
};

export default convertBootstrapToVaultData;
